import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LBtn, LHero, Loader } from "@components";
import { NavItems } from "@helpers/navigation";
import { useApi } from "@services/useApi";
import { isEmpty, orderBy } from "lodash";
import { AssessmentBasket } from "./checkout";
import { useLocalStorage, LocalStorageKey } from "@helpers/localStorageHelper";
import { useQuery } from "@utils/useQuery";

export const PurchaseCompleted = (): JSX.Element => {
    const [isLoading, setIsLoading] = useState(true);
    const [order, setOrder] = useState(0);
    const navigate = useNavigate();
    const { allParams } = useQuery();
    const [assessmentBasket, , cleanAssessmentBasket] = useLocalStorage<AssessmentBasket>(
        LocalStorageKey.AssessmentBasket
    );

    const { getPurchases } = useApi();

    useEffect(() => {
        void getOrder();
    }, []);

    const getOrder = useCallback(async () => {
        const purchases = await getPurchases(assessmentBasket.organizationId);

        if (!isEmpty(purchases.items)) {
            let purchase = orderBy(purchases.items, (x) => x.id)[purchases.items.length - 1];

            if (allParams?.session_id) {
                const purchaseSession = purchases.items.find((x) => x.checkoutSessionId === allParams.session_id);
                if (purchaseSession) {
                    purchase = purchaseSession;
                }
            }

            if (purchase) {
                setOrder(purchase.id);
            }
        }

        setIsLoading(false);
    }, []);

    const handleOnGo = async (): Promise<void> => {
        cleanAssessmentBasket();

        navigate(NavItems.Admin.Manage.Overview.path);
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <LHero contentCentered centered isFullheight>
            <div className="columns is-justify-content-center">
                <div className="column is-two-thirds">
                    <div className="title is-1 pb-6">
                        {"Thank you! We have received your order and is being processed now."}
                    </div>
                    <div className="subtitle is-3">
                        {`You order number is ${order}. You will receive an email confirmation once the order is processed.`}
                    </div>
                    <div className="buttons is-centered section">
                        <LBtn type="button" isLarge onClick={handleOnGo}>
                            {"Go to account overview"}
                        </LBtn>
                    </div>
                </div>
            </div>
        </LHero>
    );
};
